import React from 'react';
import { ICountry, ILocation } from 'interfaces';
import { OptionProps, components as c } from 'react-select';
import { getHighlightedText } from 'utils/getHighlightedText';
import { Icon } from 'view/atoms';
import { check } from 'static/icons/resizable';
import {
  cityTranslate,
  countryTranslate,
  localizationTranslate,
} from 'utils/localizationTranslate';
import { useTranslation } from 'react-i18next';

const getCustomOption =
  <T extends ILocation | ICountry>(
    getLabel: (language: string, data: T) => string,
  ) =>
  ({ data, isSelected, selectProps, ...props }: OptionProps<T>) => {
    const { inputValue } = selectProps;

    const { i18n } = useTranslation();
    const { language } = i18n;

    const label = getLabel(language, data);
    const testId = `countryDropdownOption-${label.replace(/\s+/g, '-')}`;

    return (
      <c.Option
        data={data}
        isSelected={isSelected}
        selectProps={selectProps}
        {...props}
      >
        <div data-testid={testId}>
          {getHighlightedText(label, inputValue, { color: 'black' })}
        </div>

        {isSelected && <Icon src={check} alt='check' />}
      </c.Option>
    );
  };

export const CityCustomOption = getCustomOption<ILocation>((language, data) =>
  data.cityName === 'Remote'
    ? localizationTranslate(language, data)
    : cityTranslate(language, data),
);

export const CountryCustomOption = getCustomOption<ICountry>((language, data) =>
  countryTranslate(language, data),
);
